import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import BookingParts from "./BookingParts";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../firebase.init";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import Loading from "../Shared/Loading";

const PartDetail = () => {
  const [user] = useAuthState(auth);
  const { partId } = useParams();
  const [parts, setParts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch(`https://mbababd24.onrender.com/product/${partId}`)
      .then((res) => res.json())
      .then((data) => {
        setParts(data);
        setLoading(false);
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
  }, [partId]);

  const { img, name, price, quantity, description } = parts;

  const nPrice = parseInt(price);
  let listPrice = 0;
  if (40000 < nPrice) {
    listPrice = nPrice * 0.1 + nPrice;
  } else if (10000 < nPrice) {
    listPrice = nPrice * 0.2 + nPrice;
  } else if (5000 < nPrice) {
    listPrice = nPrice * 0.25 + nPrice;
  } else if (2000 < nPrice) {
    listPrice = nPrice * 0.3 + nPrice;
  } else if (1500 < nPrice) {
    listPrice = nPrice * 0.35 + nPrice;
  } else if (500 < nPrice) {
    listPrice = nPrice * 0.4 + nPrice;
  } else {
    listPrice = nPrice * 0.5 + nPrice;
  }

  return (
    <section className="mb-10 text-accent max-w-7xl mx-auto">
      <h1 className="md:text-5xl text-3xl text-center text-accent mt-5 mx-2">
        Product Detail{" "}
        <span className="text-transparent  bg-clip-text bg-gradient-to-r from-accent to-green-400">
          {name}
        </span>
      </h1>

      {!loading ? (
        <article className="text-center" style={{ fontFamily: "Roboto" }}>
          <div className=" m-5 p-5 bg-white rounded">
            <figure className="hover:scale-110 hover:duration-300 my-10">
              <img
                className="h-80 w-80 mx-auto"
                src={img}
                alt="Product Images"
              />
            </figure>

            <div>
              <h2 className="md:text-3xl text-lg font-bold">{name}</h2>

              <h2 className="text font-bold text-primary">
                Per unit Price: {price} Tk
              </h2>
              <h2 className="line-through text-gray-400 ">
                Per unit list price: {listPrice} Tk
              </h2>
              <h2 className="text-1xl font-bold">
                Available Quantity:{" "}
                <span className="text-primary"> {quantity}</span>
              </h2>
              <h2 className="text-1xl font-bold">Minimum Order Quantity: 1</h2>
              <p className="py-6 text-justify">{description}</p>
              <div>
                <p className="text-justify py-5">
                  পণ্যটি কিনার জন্য তিনটা উপায় রয়েছে একটা হচ্ছে আপনি{" "}
                  <Link className="text-primary" to="/login">
                    Website login
                  </Link>{" "}
                  করে বুকিং করতে পারেন অথবা আমাদের{" "}
                  <Link
                    className="text-primary"
                    to="https://www.facebook.com/mbaba23/"
                    target="_blank"
                  >
                    Facebook Page
                  </Link>{" "}
                  এ মেসেজ দিতে পারেন অথবা{" "}
                  <Link
                    className="text-primary"
                    to="https://api.whatsapp.com/send?phone=1754675993"
                    target="_blank"
                  >
                    {" "}
                    WhatsApp
                  </Link>{" "}
                  মেসেজ দিতে পারেন।
                </p>
              </div>
            </div>
          </div>
        </article>
      ) : (
        <Loading></Loading>
      )}

      {user ? (
        <BookingParts
          key={parts._id}
          parts={parts}
          setParts={setParts}
        ></BookingParts>
      ) : (
        <div>
          <div className="grid grid-cols-3 md:gap-4 gap-0 content-around">
            <div className="text-gray-200 text-center text-3xl">
              <Link
                className="text-decoration-none text-primary"
                to="https://www.facebook.com/mbaba23/"
              >
                <FontAwesomeIcon
                  icon={faFacebook}
                  className="p-5 text-primary hover:text-black hover:scale-110 duration-500"
                />
              </Link>
            </div>

            <div className="justify-center mt-3">
              <Link to="/signUp">
                {" "}
                <button className="btn border-2 border-white shadow-2xl btn-block text-accent capitalize bg-gradient-to-r from-secondary-400 to-primary-500 hover:from-green-500 hover:to-blue-500 font-bold">
                  Buy Now
                </button>{" "}
              </Link>
            </div>

            <div className="text-gray-200 text-center text-3xl">
              <Link
                className="text-decoration-none text-primary"
                to="https://api.whatsapp.com/send?phone=1754675993"
              >
                <FontAwesomeIcon
                  icon={faWhatsapp}
                  className="p-5 text-green-500 rounded-full hover:text-black hover:scale-110 duration-500"
                />
              </Link>
            </div>
          </div>
          <div className="collapse text-center text-accent">
            <input type="checkbox" className="peer" />
            <div className="collapse-title bg-transparent text-black-content peer-checked:bg-transparent peer-checked:text-black-content  ">
              <h2 className="text-lg py-4">✅ Why Choose Mbaba?</h2>
            </div>
            <div className="collapse-content bg-transparent text-black-content peer-checked:bg-transparent peer-checked:text-black-content md:mx-20 mx-4">
              <p className="text-justify">
                ক্যাশ অন ডেলিভারি প্রডাক্ট হাতে পেয়ে মূল্য পরিশোধ করবেন। ৭২
                ঘণ্টার মধ্যে সারা বাংলাদেশে হোম ডেলিভারি। যে কোনো দুইটি
                প্রোডাক্ট অর্ডার করলেই ডেলিভারি চার্জ ফ্রি ১০০% অরিজিনাল
                প্রডাক্ট এবং যে কোনো সমস্যায় শতভাগ সমাধানের নিশ্চয়তা। <br />{" "}
                <br />
                রিটার্ন এবং রি-ফান্ড পলিসিঃ <br />
                আমরা Mbaba এর মাধ্যমে যেহেতু ঢাকা সহ সারা বাংলাদেশ এ ডেলিভারি
                করে থাকি, যদি কোন প্রকার সমস্যা হয় যেমনঃ কালার বা ডিজাইনের কোন
                সমস্যা অথবা একটা প্রডাক্ট এর জায়গায় অন্য একটা প্রডাক্ট চলে যাওয়া
                অথবা প্রডাক্টে কোন সমস্যা থাকে, আপনি ২৪ ঘন্টার মধ্যে আমাদের সাথে
                যোগাযোগ করবেন এবং আপনার সমস্যাটি আমাদেরকে বললে আমাদের কাছে যদি
                উক্ত প্রডাক্টটি stock এ থাকে তখন আমরা আপনাদের হাতে উক্ত প্রডাক্ট
                টি পৌঁছে যাবে ৫ কর্মদিবসের মধ্যে এবং উক্ত প্রডাক্ট টি যদি
                available না থাকে সে ক্ষেত্রে আমরা ৫ কর্মদিবসের মধ্যে বিকাশ বা
                ব্যাংকের মাধ্যমে আপনার টাকা আপনার কাছে পৌছে দিব। <br /> <br />
                বিশেষ দ্রষ্টব্যঃ <br />
                ২৪ ঘন্টার মধ্যে যোগাযোগ না করা হলে, সেক্ষেত্রে আপনার কোন অভিযোগ
                ই গ্রহনযোগ্য হবে না। প্রডাক্ট এর কোন সমস্যা ব্যাতিতো আমরা কখনই
                প্রডাক্ট রিটার্ন বা এক্সচেঞ্জ করে থাকিনা।
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default PartDetail;
